import { render } from "./AddPatient.vue?vue&type=template&id=5c674264&scoped=true"
import script from "./AddPatient.vue?vue&type=script&lang=ts"
export * from "./AddPatient.vue?vue&type=script&lang=ts"

import "./AddPatient.vue?vue&type=style&index=0&id=5c674264&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5c674264"

export default script